import React from 'react';
import { BreadcrumbsProps, Breadcrumb as BreadcrumbValue } from '../../../wag-react/components/Breadcrumbs';
import { Typography } from '../../../wag-react/components/Typography';
import { LI } from '../../../wag-react/core-components/li';
import { Link } from '../../../wag-react/core-components/link';
import { UL } from '../../../wag-react/core-components/ul';
import { BoxProps } from '../../../wag-react/next-components/box';
import { ChevronRightIcon } from '../../../wag-react/next-components/icons';
export type ArticleBreadcrumbsValue = BreadcrumbValue[];
type Props = Omit<BoxProps, 'value'> & Omit<BreadcrumbsProps, 'list'> & {
  value: ArticleBreadcrumbsValue;
};

/**
 *    This reimplements the Breadcrumbs module from @waglabs
 *    The intention is to slowly roll this out, over a few localised pages,
*     and then merged into the @waglabs repo
 */
export const ArticleBreadcrumbs = ({
  list,
  ...rest
}: BreadcrumbsProps) => <UL p={0} {...rest as Record<string, unknown>} data-sentry-element="UL" data-sentry-component="ArticleBreadcrumbs" data-sentry-source-file="ArticleBreadcrumbs.tsx">
    {list.map((item, index) => <LI key={item.title || item.url} display="inline-flex" alignItems="center" color="medGray">
        {item.url ? <>
            <Link href={item.url} title={item.title} color="inherit" pr="5px">
              <Typography variant="body2" color="inherit">
                {item.title}
              </Typography>
            </Link>

            <ChevronRightIcon pr="5px" alt={`breadcrumb-${index}`} />
          </> : <Typography fontWeight="700" variant="body2" color="inherit" pr="5px">
            {item.title}
          </Typography>}
      </LI>)}
  </UL>;
export type ArticleBreadcrumbsProps = Props;